/**
 * navlog — the English half, typed against the German module, so a
 * missing or misspelled key is a type error in this file.
 */
import type { navlog as de_navlog } from '../de/navlog';

export const navlog: Record<keyof typeof de_navlog, string> = {
  /* route rows */
  'leg.freq': 'VOR/NDB frequency',
  'leg.safealt': 'Safety altitude',
  'leg.alt': 'planned altitude/FL',
  'leg.tas': 'VE/TAS',
  'leg.wind': 'Wind W/V',
  'leg.tc': 'True course (rwK)',
  'leg.wca': 'Wind correction angle (WCA)',
  'leg.var': 'Variation (VAR)',
  'leg.mh': 'Magnetic heading (mwSK)',
  'leg.mc': 'Magnetic course (mwK)',
  'leg.dist': 'Distance of leg',
  'leg.rest_dist': 'Distance remaining',
  'leg.gs': 'Ground speed (GS)',
  'leg.time': 'Time of leg',
  'leg.rest_time': 'Time remaining',
  'leg.remark': 'Remarks/frequencies',

  /* checkpoints */
  'cp.name': 'Checkpoint',
  'cp.freq': 'VOR/NDB frequency',
  'cp.eto': 'ETO – estimated time over',
  'cp.ato': 'ATO – actual time over',
  'th.cp': 'Checkpoint',
  'th.vor': 'VOR/NDB',
  'th.safealt': 'Safety altitude',
  'th.alt': 'Alt/FL',
  'th.tas': 'TAS',
  'th.wind': 'Wind',
  'th.tc': 'rwK',
  'th.var': 'VAR',
  'th.wca': 'WCA',
  'th.mh': 'mwSK',
  'th.mc': 'mwK',
  'th.dist': 'NM',
  'th.rest_dist': 'Rem.',
  'th.gs': 'GS',
  'th.time': 'min',
  'th.rest_time': 'Rem.',
  'th.eto': 'ETO',
  'th.ato': 'ATO',
  'th.remark': 'Remarks',

  /* the NavLog's own columns */
  'th.sh': 'SH',
  'th.leg': 'Leg',
  'th.fromto': 'From → To',
  'th.fuel': 'Fuel',

  /* what a cell says about itself */
  'navlog.computed': 'calculated',
  'navlog.override': 'overridden by you',
  'navlog.row.alt': 'A',
  'navlog.alt.wind': 'Aether does not fetch a wind for the alternate.',
  'navlog.legend': 'Blue values are Aether’s. Type over one and it is yours.',

  'navlog.empty.title': 'No legs yet.',
  'navlog.empty.line': 'Draw the route on the map, or search for an aerodrome.',
  'navlog.empty.action': 'Find an aerodrome',

  'navlog.title': 'Nav log',
};
